import { IOrder, IShipmentPayment } from '@/store/ducks/order/types';

export const usePurchasePixel = (order: IOrder | undefined, payment?: IShipmentPayment) => {
  if (!window.fbq || !order?.cart.products.length) return;

  localStorage.setItem('last_paid_order', order.id.toString());
  window.fbq('track', 'Purchase', {
    content_ids: order.cart.products.map((product) => product.product_id),
    content_type: 'product',
    contents: order.cart.products.map((product) => ({
      id: product.product_id,
      quantity: product.quantity,
      item_price: product.price,
    })),
    value: order.cart.items_total,
    currency: 'BRL',
    num_items: order.cart.products.length,
    order_id: order.id.toString(),
    transaction_id: payment?.nsu?.toString(),
  });
};
